/*************************************************************************
* Copyright (c) 2025 Omnineura AI Technologies Pvt Limited.
* All rights reserved.
* This code is licensed under the 'Omnineura AI License' found in the LICENSE file.
* Unauthorized copying, sharing, or use of this code is prohibited.
* The intellectual and technical concepts are proprietary to Omnineura AI Technologies Pvt Limited.
* Author: surya@Omnineura.ai
* Date: 11-09-2025
*************************************************************************/


import { useEffect, useState } from "react";
import { useSelector, useDispatch } from "react-redux";
import { Navigate, Outlet } from "react-router-dom";
import { setUser } from "./reducers/login";
import { getAllKnowledgeBase, fetchActiveKnowledgeBase } from "./reducers/knowledgeBaseReducer";
import { fetchDocuments } from "./reducers/uploadDocReducer";
import Loader from "./loaders/Loader";

const ProtectedRoute = () => {
  const user = useSelector((state) => state.auth.user);
  const dispatch = useDispatch();
  const [checking, setChecking] = useState(!user); // only check if user is not already loaded

  useEffect(() => {
    if (!user) {
      const checkSession = async () => {
        try {
          if (!process.env.REACT_APP_BASE_URL) {
            return;
          }

          const res = await fetch(`${process.env.REACT_APP_BASE_URL}/auth/test-auth`, {
            credentials: "include",
          });
          if (res.ok) {
            const data = await res.json();
            dispatch(setUser({
              username: data.username,
              email: data.email,
              subscription: data.roles,
            }));
            dispatch(getAllKnowledgeBase());
            dispatch(fetchActiveKnowledgeBase());
            dispatch(fetchDocuments());
          }
        } catch (_err) {
          // Silently treat auth/network failures as unauthenticated.
        } finally {
          setChecking(false); // done checking
        }
      };

      checkSession();
    } else {
      dispatch(getAllKnowledgeBase());
      dispatch(fetchActiveKnowledgeBase());
      dispatch(fetchDocuments());
      setChecking(false); // user already exists, no need to check
    }
  }, [user, dispatch]);

  if (checking) {
    return <Loader />; // show loader while checking session
  }

  return user ? <Outlet /> : <Navigate to="/login" replace />;
};

export default ProtectedRoute;

